import React, { useEffect } from 'react'

import CreatorList from '@/components/shared/creator-list'
import Page from '@/components/shared/page'
import { readAllCreators } from '@/redux/creator-actions'
import { selectAccessibleCreators } from '@/redux/creator-selector'
import {
  createAppSelector,
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'

import PostList from './components/post-list'
import s from './post.module.css'

const selector = createAppSelector(
  [
    selectAccessibleCreators,
    (state) => state.creator.selectedCreatorId,
    (state) => state.global.permissionKey,
  ],
  (creators, selectedCreatorId, permissionKey) => {
    const selectedCreator = creators.find(({ id }) => id === selectedCreatorId)

    return {
      selectedCreator,
      permissionKey,
    }
  },
)

export default function Posts() {
  const { selectedCreator, permissionKey } = useAppSelector(selector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    void dispatch(readAllCreators({ permissionKey }))
  }, [dispatch, permissionKey])

  return (
    <>
      <Page sider={<CreatorList />} contentClassName={s.Content}>
        {selectedCreator && (
          <PostList
            creatorId={selectedCreator.id}
            id={selectedCreator.onlyFansUserId}
          />
        )}
      </Page>
    </>
  )
}
